import _ from 'underscore';
import ko from 'knockout';

/**
 * define read only computed observable
 * @param {Object|String} param - string or object with property depnds and computedBy
 * @param {Object} viewModel - model value of entity
 * @returns {Observable} - return observable with default value from param
 */
export function generate(param, viewModel) {
  if (_.isObject(param)) {
    const { depends, computedBy } = param;

    return ko.computed(() =>
      computedBy(..._.map(depends, dependency => viewModel[dependency]())));
  }
  return ko.observable(param);
}
